export interface Category {
  id: number;
  name: string;
  url: string;
  count: string;
  description: string;
  imgSrc: string;
}

export const categories: Category[] = [
  {
    id: 1,
    name: "Shoes",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    count: "2,450+",
    description: "Sneakers, boots, and casual footwear tracked daily",
    imgSrc: "https://readdy.ai/api/search-image?query=Pair%20of%20white%20leather%20sneakers%20on%20a%20wooden%20bench%20in%20a%20sunlit%20park%2C%20green%20grass%20blurred%20background%2C%20fresh%20spring%20morning%2C%20outdoor%20lifestyle%20photography%2C%20bright%20natural%20light%2C%20warm%20sunlight%20flares%2C%20active%20casual%20vibe&width=800&height=480&seq=cat-v2-shoes&orientation=landscape",
  },
  {
    id: 2,
    name: "Hoodies / Sweaters",
    url: "https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html",
    count: "1,830+",
    description: "Premium hoodies and knitwear from top suppliers",
    imgSrc: "https://readdy.ai/api/search-image?query=Cozy%20oversized%20knit%20sweater%20draped%20over%20a%20vintage%20armchair%20by%20a%20fireplace%2C%20warm%20amber%20glow%2C%20rustic%20cabin%20interior%2C%20soft%20wool%20texture%20visible%2C%20autumn%20comfort%20aesthetic%2C%20hygge%20lifestyle%20photography%2C%20rich%20earth%20tones&width=800&height=480&seq=cat-v2-hoodies&orientation=landscape",
  },
  {
    id: 3,
    name: "T-Shirts",
    url: "https://kaspreadsheet.com/category-913-T-Shirts.html",
    count: "3,120+",
    description: "Graphic tees, basics, and designer t-shirts",
    imgSrc: "https://readdy.ai/api/search-image?query=Folded%20cotton%20t-shirts%20in%20pastel%20colors%20stacked%20on%20a%20white%20shelf%20against%20light%20wall%2C%20soft%20studio%20lighting%2C%20clean%20minimal%20retail%20display%2C%20gentle%20mint%20pink%20and%20lavender%20hues%2C%20fresh%20summer%20vibe%2C%20editorial%20product%20photography&width=800&height=480&seq=cat-v2-tshirts&orientation=landscape",
  },
  {
    id: 4,
    name: "Jackets",
    url: "https://kaspreadsheet.com/category-914-Jackets.html",
    count: "1,560+",
    description: "Winter coats, bombers, and lightweight jackets",
    imgSrc: "https://readdy.ai/api/search-image?query=Sleek%20leather%20jacket%20hanging%20on%20a%20minimalist%20coat%20rack%20in%20a%20modern%20loft%2C%20industrial%20window%20backlight%2C%20urban%20cityscape%20through%20glass%2C%20moody%20grey%20sky%2C%20contemporary%20fashion%20editorial%2C%20polished%20concrete%20floor&width=800&height=480&seq=cat-v2-jackets&orientation=landscape",
  },
  {
    id: 5,
    name: "Pants / Shorts",
    url: "https://kaspreadsheet.com/category-915-Pants%2FShorts.html",
    count: "2,080+",
    description: "Jeans, cargo pants, shorts, and tailored trousers",
    imgSrc: "https://readdy.ai/api/search-image?query=Well%20fitted%20denim%20jeans%20folded%20neatly%20on%20a%20rustic%20wooden%20table%20next%20to%20a%20plant%2C%20morning%20light%20through%20sheer%20curtains%2C%20casual%20everyday%20essentials%2C%20warm%20brown%20and%20indigo%20tones%2C%20lifestyle%20product%20photography%2C%20natural%20home%20setting&width=800&height=480&seq=cat-v2-pants&orientation=landscape",
  },
  {
    id: 6,
    name: "Headwear",
    url: "https://kaspreadsheet.com/category-916-Headwear.html",
    count: "980+",
    description: "Caps, beanies, bucket hats, and accessories",
    imgSrc: "https://readdy.ai/api/search-image?query=Collection%20of%20stylish%20caps%20and%20a%20beanie%20arranged%20on%20a%20circular%20woven%20rug%2C%20overhead%20view%2C%20bright%20skylight%20illumination%2C%20varied%20fabrics%20and%20colors%2C%20playful%20editorial%20arrangement%2C%20clean%20geometric%20composition%2C%20bohemian%20touch&width=800&height=480&seq=cat-v2-headwear&orientation=landscape",
  },
  {
    id: 7,
    name: "Sets",
    url: "https://kaspreadsheet.com/category-917-Sets.html",
    count: "740+",
    description: "Matching outfit sets and coordinated collections",
    imgSrc: "https://readdy.ai/api/search-image?query=Matching%20hoodie%20and%20jogger%20set%20displayed%20on%20a%20mannequin%20against%20a%20soft%20blush%20backdrop%2C%20studio%20lighting%20with%20diffused%20shadows%2C%20athleisure%20aesthetic%2C%20monochrome%20grey%20outfit%2C%20modern%20fashion%20retail%20photography%2C%20clean%20professional%20presentation&width=800&height=480&seq=cat-v2-sets&orientation=landscape",
  },
  {
    id: 8,
    name: "Underwear / Underpants",
    url: "https://kaspreadsheet.com/category-918-underwear%2Funderpants.html",
    count: "1,340+",
    description: "Boxers, briefs, and essential undergarments",
    imgSrc: "https://readdy.ai/api/search-image?query=Soft%20cotton%20underwear%20basics%20folded%20with%20a%20eucalyptus%20branch%20on%20white%20linen%2C%20morning%20sunlight%2C%20spa%20like%20clean%20atmosphere%2C%20fresh%20and%20pure%20aesthetic%2C%20wellness%20lifestyle%20photography%2C%20organic%20textures%2C%20calm%20neutral%20palette&width=800&height=480&seq=cat-v2-underwear&orientation=landscape",
  },
  {
    id: 9,
    name: "Jersey",
    url: "https://kaspreadsheet.com/category-919-Jersey.html",
    count: "890+",
    description: "Sports jerseys, team kits, and athletic wear",
    imgSrc: "https://readdy.ai/api/search-image?query=Colorful%20sports%20jersey%20hanging%20in%20a%20locker%20room%20with%20warm%20spotlight%2C%20athletic%20environment%2C%20team%20spirit%20energy%2C%20bold%20red%20and%20white%20stripes%2C%20stadium%20lighting%20mood%2C%20sports%20editorial%20photography%2C%20dynamic%20composition&width=800&height=480&seq=cat-v2-jersey&orientation=landscape",
  },
  {
    id: 10,
    name: "Accessories",
    url: "https://kaspreadsheet.com/category-920-Accessories.html",
    count: "1,670+",
    description: "Watches, sunglasses, jewelry, and small goods",
    imgSrc: "https://readdy.ai/api/search-image?query=Elegant%20watch%20and%20sunglasses%20arranged%20with%20a%20leather%20wallet%20on%20a%20dark%20slate%20surface%2C%20natural%20window%20reflection%2C%20luxury%20minimalist%20display%2C%20gold%20and%20black%20accents%2C%20sophisticated%20gentleman%20aesthetic%2C%20editorial%20product%20photography&width=800&height=480&seq=cat-v2-accessories&orientation=landscape",
  },
  {
    id: 11,
    name: "Bags",
    url: "https://kaspreadsheet.com/category-921-Bags.html",
    count: "1,150+",
    description: "Backpacks, messenger bags, and travel luggage",
    imgSrc: "https://readdy.ai/api/search-image?query=Canvas%20backpack%20leaning%20against%20a%20brick%20wall%20in%20a%20sunny%20alley%2C%20urban%20exploration%20vibe%2C%20warm%20afternoon%20light%2C%20travel%20adventure%20mood%2C%20textured%20materials%2C%20lifestyle%20street%20photography%2C%20golden%20hour%20glow&width=800&height=480&seq=cat-v2-bags&orientation=landscape",
  },
  {
    id: 12,
    name: "Belts",
    url: "https://kaspreadsheet.com/search-922/name/Bags.html",
    count: "520+",
    description: "Leather belts, casual belts, and designer pieces",
    imgSrc: "https://readdy.ai/api/search-image?query=Rolled%20genuine%20leather%20belts%20with%20brass%20buckles%20placed%20on%20an%20aged%20oak%20table%2C%20side%20lighting%20casting%20long%20shadows%2C%20artisan%20craftsmanship%20detail%2C%20rich%20cognac%20and%20chestnut%20hues%2C%20heritage%20workshop%20aesthetic%2C%20fine%20product%20photography&width=800&height=480&seq=cat-v2-belts&orientation=landscape",
  },
  {
    id: 13,
    name: "Perfumes",
    url: "https://kaspreadsheet.com/search-923/name/Bags.html",
    count: "630+",
    description: "Designer fragrances, niche perfumes, and colognes",
    imgSrc: "https://readdy.ai/api/search-image?query=Crystal%20perfume%20bottle%20with%20rose%20petals%20scattered%20on%20a%20mirror%20surface%2C%20soft%20pink%20lighting%2C%20romantic%20luxury%20atmosphere%2C%20reflective%20elegant%20composition%2C%20fragrance%20concept%2C%20high%20end%20beauty%20editorial%2C%20delicate%20floral%20accents&width=800&height=480&seq=cat-v2-perfumes&orientation=landscape",
  },
  {
    id: 14,
    name: "Other Stuff",
    url: "https://kaspreadsheet.com/search-924/name/Bags.html",
    count: "1,090+",
    description: "Electronics, home goods, and miscellaneous finds",
    imgSrc: "https://readdy.ai/api/search-image?query=Eclectic%20collection%20of%20lifestyle%20items%20including%20a%20camera%20notebook%20and%20ceramic%20mug%20on%20a%20desk%2C%20warm%20desk%20lamp%20glow%2C%20creative%20workspace%20vibe%2C%20personal%20curated%20aesthetic%2C%20cozy%20evening%20atmosphere%2C%20blogger%20flat%20lay%20style&width=800&height=480&seq=cat-v2-otherstuff&orientation=landscape",
  },
];